import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import type Policy from 'modules/payroll_bundle/store/models/Policy'

interface Props {
  policies: Policy[]
  onClose: () => void
  addPolicy: (id: string | null) => void
}

const ConfirmModal = ({ onClose, policies, addPolicy }: Props) => {
  const [selectedPolicyId, setSelectedPolicyId] = React.useState<string | null>(policies[0]?.id)

  const policyOptions = () => {
    return policies.map((policy) => ({
      label: policy.attributes.name,
      value: policy.attributes.id,
    }))
  }

  return (
    <Modal
      illustration="money-bag"
      title={i18n.t('contract_versions.forms.payroll_policy.confirm_modal.title')}
      description={i18n.t('contract_versions.forms.payroll_policy.confirm_modal.description')}
      onClose={onClose}
      onSubmit={() => addPolicy(selectedPolicyId)}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>
            {i18n.t('contract_versions.forms.payroll_policy.confirm_modal.title')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <SelectField
          label={i18n.t('contract_versions.forms.payroll_policy.confirm_modal.payroll_policy')}
          value={String(selectedPolicyId)}
          options={policyOptions()}
          onChange={(id) => setSelectedPolicyId(id)}
          showOriginalLabelText
          mandatory
        />
      </Box>
    </Modal>
  )
}

export default observer(ConfirmModal)
